import { useController } from "react-hook-form";
import { SizeProp } from "chakra-react-select/dist/types/types";

import { Select } from "components/Select";
import { InputWrapper, InputWrapperProps } from "./FormInputs";

const SelectFormInput = ({
  id,
  options,
  isLoading,
  placeholder,
  isClearable,
  size,
  ...rest
}: InputWrapperProps & {
  options?: (SelectOption | GroupedSelectOption)[];
  isLoading?: boolean;
  isClearable?: boolean;
}) => {
  const { field, fieldState } = useController({ name: id });
  return (
    <InputWrapper
      id={id}
      errorMsgOverride={fieldState.error?.message}
      {...rest}
    >
      <Select
        placeholder={placeholder}
        options={options}
        isLoading={isLoading}
        isClearable={isClearable}
        size={size as SizeProp}
        {...field}
      />
    </InputWrapper>
  );
};

export default SelectFormInput;
